import React from 'react';
import { LinkProps } from './Link.types';
import * as Styled from './Link.styled';

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  (props, ref) => {
    const {
      children,
      disabled = false,
      color = 'primary.base',
      underline,
      href,
      target,
      ...rest
    } = props;
    return (
      <Styled.Link
        {...rest}
        {...(disabled
          ? { 'aria-disabled': true, role: 'link' }
          : { href, target })}
        $disabled={disabled}
        $color={color}
        $underline={underline}
        ref={ref}
      >
        {children}
      </Styled.Link>
    );
  },
);

export default Link;
